import React, { useRef } from 'react';
import logo from './logo.svg';
import mobileLogo from './logo-mobile.svg';
import ToyotaButton from '../ToyotaButton';
import { useMobileBreakpoint, useTabletBreakpoint } from '../breakpoints';
import { useTranslation } from 'react-i18next';
import { PortfoliosSection } from './components/PortfoliosSection';
import Typography from '../Typography';
import { Burger } from './components/Burger';

import { 
  Container, 
  Wrapper, 
  Logo, 
  LogoImage, 
  Link, 
  Section,
  LanguageSection,
  LanguageButton,
  Separator,
  About
} from './index.styled';

const scrollToElement = require('scroll-to-element');

const handleOnClick = (e) => {
  const href = e.target.getAttribute('href');
  if (href && document.querySelector(href)) {
    e.preventDefault();
    scrollToElement(href, {
      offset: -100,
      ease: 'out-quad',
      duration: 700
    });

    // Track contact us click
    if (window.gtag) {
      const gaGroup = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
      window.contactSource = {
        category: `topnav`,
        label: `${gaGroup}:contact:submission`
      }
      window.gtag('event', 'contact-click', { 'event_category': 'topnav', 'event_label': `${gaGroup}:contact`, 'send_to': gaGroup });
    }
    
  }
};

const SiteNavigation = () => {
  const { t, i18n } = useTranslation()
  const languageRef = useRef(null);
  const isIE = /*@cc_on!@*/false || !!document.documentMode;

  const clearLanguageBar = () => {
    const languages = Array.from(languageRef.current.children)
    languages.forEach(lang => lang.classList.remove('active'))
  }
  const toggleLanguage = e => {
    e.preventDefault()
    clearLanguageBar()
    const { value } = e.target
    i18n.changeLanguage(value)
    e.target.classList.add('active')
    document.location.reload()
  }

  const handleScrollTop = () => {
    window.scrollTo(0, 0);
  }

  const isTablet = useTabletBreakpoint();
  const isMobile = useMobileBreakpoint();
  const logoAsset = (isMobile || isTablet) ? mobileLogo : logo;
  const logoSize = (isMobile || isTablet)  ? '140px' : '300px';


  return (
    <Container>
      {
        !isMobile && (
          <LanguageSection ref={languageRef}>
            <LanguageButton onClick={e=> toggleLanguage(e)} value='en'>
              English
            </LanguageButton>
            <Separator>|</Separator>
            <LanguageButton onClick={e => toggleLanguage(e)} value='ja'>
              &nbsp;{t('Languages.japanese')}
            </LanguageButton>
          </LanguageSection>
        )
      }
      <Wrapper>
        <Logo to='/' ie={isIE.toString()} onClick={handleScrollTop}>
          <LogoImage isMobile={isMobile}>
            <img src={logoAsset} alt='Toyota IP Solutions' width={logoSize} />
          </LogoImage>
        </Logo>
        {
          !isMobile ?
          (
            <>
              <Section>
                <PortfoliosSection />
                <About onClick={handleScrollTop}>
                  <Typography.NavItem>
                    <Link to='/about'>{t('SiteNavData.about.title')}</Link>
                  </Typography.NavItem>
                </About>
              </Section>
              <Typography.NavItem>
                <ToyotaButton href='#contact' onClick={handleOnClick}>{t('SiteNavData.contact.title')}</ToyotaButton>
              </Typography.NavItem>
            </>
          ):
          (
            <Burger />
          )
        }
      </Wrapper>
    </Container>
  );
};

export default SiteNavigation;
